// frontend/src/components/ErrorModal.js
import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  VStack,
  HStack,
  Alert,
  AlertIcon
} from '@chakra-ui/react';

const ErrorModal = ({ 
  isOpen, 
  onClose, 
  errorInfo 
}) => {
  if (!errorInfo || !errorInfo.showModal) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <HStack>
            <Text>{errorInfo.icon}</Text>
            <Text>{errorInfo.modalTitle || errorInfo.title}</Text>
          </HStack>
        </ModalHeader>
        
        <ModalBody>
          <VStack align="stretch" spacing={4}>
            <Alert status="error" borderRadius="md">
              <AlertIcon />
              <Text fontSize="sm">
                {errorInfo.modalMessage || errorInfo.message}
              </Text>
            </Alert>
            
            <Text fontSize="sm" color="gray.600">
              This issue requires administrator attention. Please save your work 
              and contact support if the problem persists.
            </Text>
          </VStack>
        </ModalBody>
        
        <ModalFooter>
          <Button colorScheme="blue" onClick={onClose}>
            OK
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ErrorModal;